export default __webpack_public_path__ + "assets/fonts/BEBASNEUE-REGULAR.woff2";